'use client';

import dynamic from 'next/dynamic';

const CustomerTypeDialog = dynamic(
  () => import('./CustomerTypeDialog').then((m) => ({ default: m.CustomerTypeDialog })),
  { ssr: false }
);

// PushBanner togs bort 2026-09-03. Den var 231 px hög med z-[99] och visades
// för varje ny besökare som scrollat 200 px, på varje sida — och gav sex
// prenumeranter på 90 dagar. Push kan fortfarande slås på av kunden själv från
// /konto och från företagsportalen; det som försvann är avbrottet, inte kanalen.
// De 86 befintliga prenumerationerna och adminverktyget för utskick är orörda.

export function LazyOverlays() {
  return (
    <>
      <CustomerTypeDialog />
    </>
  );
}
